import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import SelectCustom from '../../../SelectCustom';
import styles from './styles.styl';

function ResultsCard({
  title,
  list,
  value,
  label,
  danger,
  onChange,
  disabled,
  children,
  subtitle,
  readOnly,
}) {
  return (
    <div className={styles.root}>
      <div className={styles.details}>{children}</div>
      <div className={styles.content}>
        <h3 className={cn(styles.title, { [styles.titleDanger]: danger })}>
          {title}
        </h3>
        <p className={styles.subtitle}>{subtitle}</p>
        <SelectCustom
          disabled={disabled}
          value={value}
          label={label}
          options={list}
          onChange={({ value }) => onChange(value)}
          needUpdateDefaultValue
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}

ResultsCard.propTypes = {
  title: PropTypes.string,
  list: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  danger: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default ResultsCard;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/Components/ResultsCard/index.jsx